import UpdateBook from "./update-book.page";

export default UpdateBook;
